$(document).ready(function () {
  var sliders = [
    {
        selector: '.recommendations .carousel-recommendations .pdp-tiles-container',
        initialize: initializeHorizontalSlickSlider,
    },
    {
        selector: '.recommendations .carousel-recommendations .pdp-vertival-tiles-container',
        initialize: initializeVerticalSlickSlider,
    },
    {
        selector: '.product-recomm-clp .product-recom-slider .product-recom-slider-recomm',
        initialize: initializeHorizontalSlickSliderProduct,
    },
    {
        selector: '.cart-recommendations .product-recom-slider .product-recom-slider-recomm',
        initialize: initializeHorizontalSlickSliderCart,
    },
    {
        selector: '.product-recom-slider .custom-carousel .home-asset-product-recomm',
        initialize: initializeHorizontalSlickSliderHome,
    },
    {
        selector: '.product-recom-slider .tiles-container',
        initialize: initializeNoSearchResultSlickSlider,
    },
    {
        selector: '#cart-modal .product-recom-slider .tiles-container',
        initialize: initializeAddToCartModalSlickSlider,
    }
  ];

  const initializeSlider = function (slider) {
      const $targetElement = $(slider.selector);
      if ($targetElement.length > 0 && !$targetElement.hasClass('slick-initialized')) {
          slider.initialize();
      }
  };

  var checkSelectors = function () {

    sliders.forEach((slider) => {
        initializeSlider(slider);
    });

    // Continue checking for selectors after a short delay
    setTimeout(checkSelectors, 1000);
};

  // Initial check when the document is ready
  checkSelectors();
});

function initializeVerticalSlickSlider() {
  initializeSlickSlider('.recommendations .carousel-recommendations .pdp-vertival-tiles-container', 2, $(window).width() > 768);
}

function initializeHorizontalSlickSlider() {
  initializeSlickSlider('.recommendations .carousel-recommendations .pdp-tiles-container', 4);
}

function initializeHorizontalSlickSliderProduct() {
  initializeSlickSlider('.product-recomm-clp .product-recom-slider .product-recom-slider-recomm', 4);
}

function initializeHorizontalSlickSliderCart() {
    initializeSlickSlider('.cart-recommendations .product-recom-slider .product-recom-slider-recomm', 3);
}

function initializeHorizontalSlickSliderHome() {
  initializeSlickSlider('.product-recom-slider .custom-carousel .home-asset-product-recomm', 4);
}

function initializeNoSearchResultSlickSlider() {
    initializeSlickSlider('.product-recom-slider .tiles-container', 3);
}

function initializeAddToCartModalSlickSlider() {
    initializeSlickSlider('#cart-modal .product-recom-slider .tiles-container', 3);
}

function initializeSlickSlider(selector, slidesToShow, vertical = false) {
  const util = __webpack_require__(/*! ./util */ "./janieandjack-sfra/cartridges/app_janieandjack_storefront/cartridge/client/default/js/util.js");
  const $selector = $(selector);

  // Define the number of slides for different viewports
  const responsiveSettings = [
      {
          breakpoint: 992,  // Breakpoint for tablets
          settings: {
              slidesToShow: 3,
          },
      },
      {
          breakpoint: 576,  // Breakpoint for mobile devices
          settings: {
              slidesToShow: 2,
          },
      },
  ];

  if (!($selector.hasClass('slick-initialized'))) {
      $selector.slick({
          arrows: true,
          dots: false,
          slidesToShow: slidesToShow,
          slidesToScroll: 1,
          vertical: vertical,
          verticalSwiping: vertical,
          prevArrow: '<a class="slider-prev">' + util.svg('Arrow_small', 'left-arrow') + '</a>',
          nextArrow: '<a class="slider-next">' + util.svg('Arrow_small', 'right-arrow') + '</a>',
          responsive: (vertical) ? {} : responsiveSettings
      });

      const containerClasses = [
          '.image-container',
          '.image-container',
          '.image-container',
          '.image-container',
          '.image-container',
      ];

      containerClasses.forEach((containerClass) => {
          $selector.find(containerClass).addClass("pl-2").addClass("pr-2");
      });

      if (vertical) {
          const verticalSliderStyles = {
              'slider-next': { top: '100%', right: '50%', transform: 'translateX(-50%) rotate(90deg)' },
              'slider-prev': { top: '0', left: '50%', transform: 'translateX(-50%) rotate(90deg)' },
          };

          Object.keys(verticalSliderStyles).forEach((sliderClass) => {
              $selector.find(`.${sliderClass}`).css(verticalSliderStyles[sliderClass]);
          });
      }
  }
    const cartRecommendations = $(".cart-recommendations.large-up");
    const isSlickInitialized = cartRecommendations.find('.slick-initialized').length > 0;
    const isWindowWidthLessThan767 = $(window).width() < 767;

    if (isSlickInitialized && isWindowWidthLessThan767) {
        $(".promoandrecomm").append(cartRecommendations);
    }
}
